<template>
  <section class="pulse-summary" :class="`pulse-summary--${tone}`">
    <div class="pulse-summary__content">
      <div class="pulse-summary__icon">
        <i :class="icon" />
      </div>
      <div class="pulse-summary__text">
        <p class="pulse-summary__title">{{ title }}</p>
        <div class="pulse-summary__value-wrap">
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="26"
            width="3"
            color="#6366f1"
          />
          <p v-else class="pulse-summary__value">
            {{ value === null || value === undefined ? "-" : value }}
          </p>
        </div>
        <p v-if="description" class="pulse-summary__description">
          {{ description }}
        </p>
      </div>
    </div>
    <div class="pulse-summary__accent" />
  </section>
</template>

<script>
export default {
  name: "PulseSummaryCard",
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: "-" },
    description: { type: String, default: "" },
    icon: { type: String, default: "pi pi-list-check" },
    loading: Boolean,
    tone: {
      type: String,
      default: "blue",
      validator: (v) => ["blue", "green", "amber", "slate", "red"].includes(v),
    },
  },
};
</script>
